import React from 'react';
import { Typography } from 'fronton-react';
import { styled } from 'linaria/react';
import { useTranslation } from 'react-i18next';
import { RoomParams } from './components/RoomParams';
import { Hints } from './components/Hints';
import { Result } from './components/Result';
import { LaminateCalculateBannerResult } from './components/LaminateCalculateBanner';
import { AddToCart } from './components/AddToCart';
import { BasketLogicSnackbar } from '../common/components/BasketLogicSnackbar';
import { AddToShoppingList } from './components/AddToShoppingList';

export function CalculationForm() {
  const { t } = useTranslation();

  return (
    <CalculationFormContainer>
      <ParamsHeaderContainer>
        <Typography variant="h2" color="text-primary">
          {t('calculator.calculation.header.main')}
        </Typography>
        <AddToShoppingList />
      </ParamsHeaderContainer>

      <CalculationFormRow>
        <CalculationFormColumn>
          <Result />
          <LaminateCalculateBannerResult />
        </CalculationFormColumn>
        <CalculationFormColumnLeft>
          <RoomParams />
          <AddToCart />
        </CalculationFormColumnLeft>
      </CalculationFormRow>
      <BasketLogicSnackbar />
      <Hints />
    </CalculationFormContainer>
  );
}

const CalculationFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-400);
  height: 100%;
  margin-top: var(--space-200);

  @media (max-width: 768px) {
    gap: var(--space-250);
  }
`;

const ParamsHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const CalculationFormColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 2;
`;
const CalculationFormColumnLeft = styled.div`
  display: flex;
  flex-direction: column;

  @media (--to-tablet) {
    position: relative;
    bottom: var(--space-200);
    margin-top: auto;
  }
`;

const CalculationFormRow = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: var(--space-500);

  & > div {
    max-width: 548px;
    @media (max-width: 1024px) {
      max-width: 100%;
    }
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    height: 100%;
    & > div {
      max-width: 100%;
    }
  }
`;
